import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { PrivatePageWrapper } from './PrivateRouteWrapper';
import { HomePage } from '../pages/HomePage';
import { SignUpPage } from '../pages/SignUpPage';
import { paths } from './paths';
import { ReceivedDigitalDossierAccessRequestsPage } from '../pages/ReceivedDigitalDossierAccessRequestsPage';
import { SharedDigitalDossierPage } from '../pages/SharedDigitalDossierPage';
import { DossierExplorerPage } from '../pages/DossierExplorerPage';
import { ErrorPage } from '../pages/ErrorPage';
import UserProfilePage from '../pages/UserProfilePage';
import { CropPledgePage } from '../pages/CropPledgePage';
import { CropPledgeDetailPage } from '../pages/CropPledgeDetailPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivatePageWrapper>
            <Outlet />
          </PrivatePageWrapper>
        }
      >
        <Route path={paths.home} element={<HomePage />} />
        <Route path={paths.dossierExplorer} element={<DossierExplorerPage />} />
        <Route
          path={paths.receivedAccessRequests}
          element={<ReceivedDigitalDossierAccessRequestsPage />}
        />
        <Route
          path={paths.sharedDigitalDossier}
          element={<SharedDigitalDossierPage />}
        />
        <Route path={paths.cropPledge} element={<CropPledgePage />} />
        <Route
          path={paths.cropPledgeDetail}
          element={<CropPledgeDetailPage />}
        />
        <Route path={paths.profile} element={<UserProfilePage />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>

      <Route path={SignUpPage.path} element={<SignUpPage />} />
    </Routes>
  );
};

export default AppRoutes;
